import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getArtistMedia = (id) => {
  return axios.get(URL_PREFIX + '/artist-medias/' + id + '/')
}

export const getArtistMediaPublic = (id) => {
  return axios.get(URL_PREFIX + '/artist-medias-public/?artist_id=' + id)
}

export const postArtistMedia = (param) => {
  return axios.post(URL_PREFIX + '/artist-medias/', param)
}

export const putArtistMedia = (id, param) => {
  return axios.put(URL_PREFIX + '/artist-medias/' + id + '/', param)
}

export const deleteArtistMedia = (id, is_admin, artist_id) => {
  if (is_admin) return axios.delete(URL_PREFIX + '/artist-medias/' + id + '/?artist_id=' + artist_id)
  else return axios.delete(URL_PREFIX + '/artist-medias/' + id + '/')
}
